import { render, staticRenderFns } from "./FinalReportAdministrativeHeader.vue?vue&type=template&id=1dacf7b2&"
import script from "./FinalReportAdministrativeHeader.vue?vue&type=script&lang=js&"
export * from "./FinalReportAdministrativeHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
installComponents(component, {VCard,VCardText,VFlex})
